import {createProjectModel} from 'crm/utils/project-model'
import {groups, taskDetail, list, storeFeedbackList, exportDetailData} from './service'

const model = createProjectModel({
    projectNamespace: 'taskManagementDetail',
    state: {
        groups: [],
        tableData: {},
        taskConfig: {},
        storeFeedbackTableData: {},
    },
    effects: {
        *groups({payload}, {call, put}) {
            const res = yield call(groups, payload)
            const data = res?.data || []
            yield put({
                type: 'setProperty',
                payload: {
                    groups: data,
                },
            })
        },
        *taskDetail({payload}, {call}) {
            return yield call(taskDetail, payload)
        },
        *list({payload}, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(list, {taskId: payload.taskId, params: newParams})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found || 0
                },
            })
        },
        *storeFeedbackList({payload}, {put, call}) {
            const res = yield call(storeFeedbackList, payload)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.storeFeedbackTableData.dataSource = res.data
                },
            })
        },
        // 导出
        *exportDetailData({payload}, {call}) {
            return yield call(exportDetailData, payload)
        },
    },
    reducers: {},
})

export default model
